import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Accreditation from "@/pages/Accreditation";
import Certifications from "@/pages/Certifications";
import Standards from "@/pages/Standards";
import FindCoach from "@/pages/FindCoach";
import Membership from "@/pages/Membership";
import Contact from "@/pages/Contact";
import FAQ from "@/pages/FAQ";

// Scroll to top on route change
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  return (
    <div className="App min-h-screen flex flex-col">
      <BrowserRouter>
        <ScrollToTop />
        <Navbar />
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/accreditation" element={<Accreditation />} />
            <Route path="/certifications" element={<Certifications />} />
            <Route path="/standards" element={<Standards />} />
            <Route path="/find-coach" element={<FindCoach />} />
            <Route path="/membership" element={<Membership />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/faq" element={<FAQ />} />
          </Routes>
        </main>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
